import styled from 'styled-components';
import tw from 'twin.macro';

export const FieldContainer = styled.div`
  ${tw`w-full`};
  ${(props) => (props.isHidden ? tw`hidden` : '')};
  ${(props) => props.css}
`;
